// Copied from redesign-theme-input.ts in CDK

import { theme } from "../../../tailwind.theme";
const { colors } = theme.extend;

// export some basic state -> color mappings so we can re-use them in our payabli theme
export const TextInputStateColorMap = {
    default: {
        color: colors.neutral[950],
        borderColor: colors.neutral[200],
        backgroundColor: colors.neutral[0]
    },
    label: {
        color: colors.neutral[700]
    },
    disabled: {
        color: colors.neutral[500],
        borderColor: colors.neutral[200],
        backgroundColor: colors.neutral[50]
    },
    focus: {
        borderColor: colors.neutral[200],
        boxShadow: `0 0 0 4px ${colors.blue[400]}`
    },
    active: {
        borderColor: colors.neutral[300]
    },
    hover: {
        borderColor: colors.neutral[300]
    },
    error: {
        color: colors.red[600]
    }
} as const;
